import { render, staticRenderFns } from "./MyRecord.vue?vue&type=template&id=66d64dbe&"
import script from "./MyRecord.vue?vue&type=script&lang=js&"
export * from "./MyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports